import * as types from './constants';
import { convertArrayToObject } from '../../utils/arrayConvert';

const initialState = {
  listData: {
    dataTable: [],
    merchants: [],
    loading: false,
    message: null,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false
  },
  deleteData: {
    data: {},
    loading: false,
    errors_api: false
  },
  columnsMemory: {}
};

const actions = {
  // Get Merchants
  [types.GET_MERCHANTS_REQUEST]: state => {
    const data = {
      ...state,
      listData: { ...state.listData, loading: true }
    };

    return { ...data };
  },

  [types.GET_MERCHANTS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        ...payload,
        loading: false
      }
    };

    return { ...data };
  },

  [types.GET_MERCHANTS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Delete Merchant
  [types.DELETE_MERCHANT_REQUEST]: state => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: true }
    };

    return { ...data };
  },

  [types.DELETE_MERCHANT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: false, data: payload }
    };

    return { ...data };
  },

  [types.DELETE_MERCHANT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      deleteData: { ...state.deleteData, loading: false, errors_api: payload }
    };

    return { ...data };
  },

  // Save Columns Width
  [types.SAVE_MERCHANTS_COLUMNS]: (state, { payload }) => {

    const data = {
      ...state,
      columnsMemory: convertArrayToObject(state.columnsMemory, payload)
    };

    return { ...data };
  },

  // Operations
  [types.MERCHANTS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: {
        ...state.listData,
        curr_page: parseInt(payload) || 1,
        queryParsed: true
      }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};